import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageFactoryService } from './storage-factory.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [StorageFactoryService],
  exports: []
})
export class StorageModule {}
